<template>
  <div>
    <split-pane :min-percent="20" :default-percent="50" split="vertical">
      <template slot="paneL" v-if="!isShowPic">
        <a-card title="学生列表">
          <!--          <a slot="extra">-->
          <!--            <a-tooltip title="提醒逻辑：1.本期平均值 低于 往期平均值 * ( 1 - 阈值% )。2.计算逻辑：先取个人单日情绪值再取所有学生平均值。3.去除周期内超一半日期无抓拍数据学生，去除双休日法定节假日数据。4.时间跨度须以周为单位较为精准，周一开始，周日结束。">-->
          <!--              <a-icon type="info-circle" style="cursor: pointer;"/>-->
          <!--            </a-tooltip>-->
          <!--          </a>-->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="24">
                <a-col :span="12">
                  <a-form-item label="时间范围">
                    <a-range-picker :value="rangeDate" @change="onRangeChange" />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="学生姓名">
                    <a-input
                      placeholder="请输入学生姓名"
                      v-model="queryParam.studentName"
                    ></a-input>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item label="年级名称">
                    <j-dict-select-tag
                      style="width: 100%"
                      placeholder="请选择年级"
                      v-model="queryParam.gradeId"
                      dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
                      :isShowEmpty="false"
                      allowClear
                      @select="$set(queryParam, 'classId', undefined)"
                      @clear="$set(queryParam, 'classId', undefined)"
                    />
                  </a-form-item>
                </a-col>

                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item label="班级名称">
                    <j-dict-select-tag
                      style="width: 100%"
                      placeholder="请选择班级"
                      v-model="queryParam.classId"
                      :dictCode="
                        'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
                      "
                      :async="true"
                      :disabled="!queryParam.gradeId"
                      :isShowEmpty="false"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="是否关爱名单">
                    <j-dict-select-tag
                      v-model="queryParam.careList"
                      placeholder="请选择是否关爱名单"
                      dictCode="yn"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="10" v-if="userInfo().username !== 'admin'">
                  <a-form-item label="提醒阈值">
                    <j-dict-select-tag
                      v-model="queryParam.threshold"
                      placeholder="请选择提醒阈值范围"
                      dictCode="warn_level"
                      style="width: calc(50% - 9px)"
                    />
                    ~
                    <j-dict-select-tag
                      v-model="queryParam.thresholdEnd"
                      placeholder="请选择提醒阈值范围"
                      dictCode="warn_level"
                      style="width: calc(50% - 9px)"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="10" v-else>
                  <a-form-item label="提醒阈值范围">
                    <a-input
                      type="number"
                      v-model="queryParam.threshold"
                      :min="0"
                      :max="100"
                      style="width: calc(50% - 9px)"
                    />
                    ~
                    <a-input
                      type="number"
                      v-model="queryParam.thresholdEnd"
                      :min="0"
                      :max="100"
                      style="width: calc(50% - 9px)"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="10">
                  <a-form-item label="提醒模型">
                    <j-multi-select-tag
                      dictCode="mood_model"
                      :options="options"
                      :filterValOpts="remindFilterValOpts"
                      :maxTagCount="1"
                      placeholder="请选择提醒模型"
                      v-model="queryParam.modelIds"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item label="持续低落天数">
                    <a-input
                      type="number"
                      v-model="queryParam.continuedLowDays"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="持续低落次数">
                    <a-input
                      type="number"
                      v-model="queryParam.continuedLowCount"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="低活跃度天数">
                    <a-input
                      type="number"
                      v-model="queryParam.lowActivityDays"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="10">
                  <a-form-item>
                    <span slot="label">
                      <a-popover>
                        <template slot="content">
                          <div style="width: 180px">
                            预警次数、预警次数小于、预警次数大于为互斥关系，每次只能筛选一个条件，每次需要清除掉已筛选条件才能重新输入其他输入框。
                          </div>
                        </template>
                        <a-icon type="question-circle" />
                      </a-popover>
                      预警次数(=)
                    </span>
                    <a-input
                      type="number"
                      v-model="queryParam.exactWarnCount"
                      :disabled="!!queryParam.minWarnCount || !!queryParam.maxWarnCount"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="14">
                  <a-form-item>
                    <span slot="label">
                      <a-popover>
                        <template slot="content">
                          <div style="width: 180px">
                            <div>
                              预警次数、预警次数范围为互斥关系，每次只能筛选一个条件，需要清除掉已筛选条件才能重新输入其他输入框。
                            </div>
                            <div>
                              预警次数范围只填写最小值为预警次数小于（<），只填写最大值为预警次数大于(>)，都填写为预警次数范围(<=
                              ~ <=)。
                            </div>
                          </div>
                        </template>
                        <a-icon type="question-circle" style="color: #ffcc3e" />
                      </a-popover>
                      预警次数范围
                    </span>
                    <a-input-group compact>
                      <a-input
                        type="number"
                        v-model="queryParam.minWarnCount"
                        :disabled="!!queryParam.exactWarnCount"
                        style="width: 120px; text-align: center"
                        placeholder="最小值"
                      />
                      <a-input
                        :style="{
                          width: '30px',
                          borderLeft: 0,
                          pointerEvents: 'none',
                          backgroundColor: !!queryParam.exactWarnCount ? '#F5F5F5' : '#fff',
                        }"
                        :disabled="!!queryParam.exactWarnCount"
                        placeholder="~"
                        disabled
                      />
                      <a-input
                        type="number"
                        v-model="queryParam.maxWarnCount"
                        :disabled="!!queryParam.exactWarnCount"
                        style="width: 120px; text-align: center; border-left: 0"
                        placeholder="最大值"
                      />
                    </a-input-group>
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :gutter="24">
                <a-col :span="8">
                  <a-form-item label="是否被干预">
                    <a-select
                      v-model="queryParam.intervened"
                      placeholder="请选择干预情况"
                      :options="interveneOptions"
                      allowClear
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="预警比例">
                    <a-input-number
                      type="number"
                      v-model="queryParam.warnRatio"
                      :min="0"
                      :max="100"
                      style="width: 100%"
                    />
                  </a-form-item>
                </a-col>
                <a-col :span="2">
                  <span
                    style="float: left; overflow: hidden"
                    class="table-page-search-submitButtons"
                  >
                    <a-button type="primary" @click="searchQuery" icon="search" :loading="loading">
                      查询
                    </a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>

          <!-- 操作按钮区域 -->
          <div class="table-operator">
            <!--            <a-button type="primary" icon="download" @click="chartToImg" :loading="loading">-->
            <!--              导出-->
            <!--            </a-button>-->
            <a-button v-has="'studentExportV2:show'" type="primary" @click="chartToImg">
              导出
            </a-button>
          </div>

          <div>
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: 'auto', y: 450 }"
              bordered
              rowKey="id"
              :columns="columnsWithOutHidden"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              loading-text="loadingText"
              @change="handleTableChange"
            >
              <a
                slot="studentName"
                :style="text === currentStudentName ? 'color:red' : ''"
                slot-scope="text, record"
                @click="changeSelect(record)"
              >
                {{ text }}
              </a>
            </a-table>
          </div>
        </a-card>
      </template>
      <template slot="paneL" v-else>
        <a-card title="照片清单">
          <a-spin tip="加载中..." :spinning="picLoading">
            <a-timeline style="overflow-y: auto; height: 700px">
              <a-timeline-item color="green" v-for="(item, index) in this.picData" :key="index">
                <p>{{ item.name }}</p>
                <div>
                  <div
                    style="width: 100px; display: inline-block"
                    v-for="(pic, uIndex) in item.data"
                    :key="uIndex"
                  >
                    <img
                      style="width: 100px; height: 100px; border: 1px solid #ccc; padding: 5px"
                      :src="getImgView(pic.faceUrl)"
                    />
                    <div v-if="userInfo().username === 'admin'" style="text-align: center">
                      {{ pic.emotion_dictText }}
                    </div>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
          </a-spin>
        </a-card>
      </template>
      <template slot="paneR">
        <a-card title="分析模型">
          <!--          <a-button v-has="'studentPic:show'" v-show="currentStudentName !== ''" type="primary" slot="extra" @click="showPic">{{ isShowPic ? '返回': '查看照片'}}</a-button>-->
          <a-button
            type="primary"
            v-show="currentStudentName !== ''"
            slot="extra"
            @click="derivedInfo"
          >
            导出
          </a-button>
          <a-spin tip="加载中..." :spinning="chartLoading">
            <div ref="exportContent" class="outer-card">
              <StuLineMoodCard
                v-for="(item, index) in studentLineArr"
                :key="index"
                :name="item.name"
                :dataSource="item.dataSource"
                :moodField="item.fileds"
                :studentInfo="item.studentInfo"
                @showImgDetail="showImgDetail(item.studentInfo)"
                :hiddenCompare="true"
                @deleteRecord="deleteRecord"
              />
            </div>
          </a-spin>
        </a-card>
      </template>
    </split-pane>
    <div style="width: 500px" id="exportChart">
      <LineChart
        v-for="(item, index) in exportChartData"
        style="width: 500px; z-index: -9999"
        height="150px"
        :fields="item.fileds"
        :dataSource="item.dataSource"
        :yAxisMultiple="1.15"
      />
    </div>
    <ImgTimeLineModal ref="imgTimeLineModal" />
  </div>
</template>

<script>
import splitPane from 'vue-splitpane'
import '@/assets/less/TableExpand.less'
import { getAction } from '@api/manage'
import { mixinDevice } from '@/utils/mixin'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import SmoothLineChartMultid from '@/components/chart/SmoothLineChartMultid'
import moment from 'moment'
import { mapGetters } from 'vuex'
import UpdateStudentFaceModal from '../studentInfo/modules/UpdateStudentFaceModal'
import JMultiSelectTag from '../../../components/dict/JMultiSelectTag.vue'
import JSearchSelectTag from '../../../components/dict/JSearchSelectTag.vue'
import StuLineMoodCard from './components/StuLineMoodCard.vue'
import { exportToPdf, handleLineChartData } from '@/utils/util'
import ImgTimeLineModal from './components/ImgTimeLineModal'
import LineChart from '../../../components/echartZyz/components/LineChart.vue'
import html2canvas from 'html2canvas'
import { postAction } from '../../../api/manage'

export default {
  name: 'StudentWarnV2',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    LineChart,
    ImgTimeLineModal,
    StuLineMoodCard,
    JSearchSelectTag,
    JMultiSelectTag,
    splitPane,
    SmoothLineChartMultid,
    UpdateStudentFaceModal,
  },
  data() {
    return {
      loading: false,
      loadingText: '',
      queryParam: {},
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 40,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '班级',
          align: 'center',
          dataIndex: 'className',
          width: 100,
          ellipsis: true,
        },
        {
          title: '学生',
          align: 'center',
          dataIndex: 'studentName',
          scopedSlots: { customRender: 'studentName' },
          width: 80,
        },
        {
          title: '情绪指数',
          align: 'center',
          children: [
            {
              title: '本期',
              align: 'center',
              dataIndex: 'currScore',
              width: 60,
            },
            {
              title: '往期',
              align: 'center',
              dataIndex: 'hisScore',
              width: 60,
            },
            {
              title: '班级',
              align: 'center',
              dataIndex: 'classScore',
              width: 60,
            },
            {
              title: '年级',
              align: 'center',
              dataIndex: 'gradeScore',
              width: 60,
            },
          ],
        },
        {
          title: '关爱名单',
          align: 'center',
          dataIndex: 'careList',
          width: 80,
          filters: [
            { text: '须关爱', value: 1 },
            { text: '正常', value: 0 },
          ],
          onFilter: (value, record) => record.careList === value,
          customRender: function (t, r, index) {
            return t === 0 ? '否' : '是'
          },
        },
        {
          title: '本学期提醒次数',
          align: 'center',
          dataIndex: 'semesterWarnNum',
          width: 80,
        },
        {
          title: '提醒内容',
          align: 'center',
          dataIndex: 'content',
          width: 80,
        },
      ],
      columnsWithOutHidden: [],
      chartLoading: false,
      currentStudentId: '',
      currentStudentName: '',
      isShowPic: false,
      isExport: false,
      rangeDate: [],
      picLoading: false,
      picData: [],
      options: [],
      interveneOptions: [
        {
          label: '是',
          value: '1',
        },
        {
          label: '否',
          value: '0',
        },
      ],
      multiSeleteTag: '',
      studentLineArr: [],
      //导出export使用
      exportChartData: [],
      url: {
        list: '/warnModel/v2/listWarnModelDataV2',
        studentWarnAnalysis: '/statistic/studentMoodAnalysis',
        studentFaceList: '/aigoes/studentFace/list',
        childWarnNumTrend: '/statistic/childWarnNumTrend',
        exportXlsUrl: '/warnModel/v2/exportWarnModelDataV2',
        getMoreStudentMoodData: '/warnModel/v2/getMoreStudentMoodDataV2',
        uploadMoodDataImg: '/statistic/uploadMoodDataImg',
      },
      // 租户为演示环境时，显示全部，租户为学校时间，只显示部分
      remindFilterValOpts: ['moodDropModel', 'moodContinuedLowModel'],
      disableMixinCreated:true
    }
  },
  created() {
    this.columnsWithOutHidden = this.columns.filter((item) => !item.hidden)
    this.rangeDate = [moment().subtract(14, 'days'), moment().subtract(1, 'days')]
    this.queryParam.beginDate = moment().subtract(14, 'days').format('YYYY-MM-DD')
    this.queryParam.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD')

    this.getData()
    let relTenantIds = this.userInfo()?.relTenantIds
    if (relTenantIds) {
      relTenantIds = relTenantIds.split(',')
    }
  },
  methods: {
    ...mapGetters(['userInfo']),
    getData() {
      this.loading = true
      this.studentLineArr = []
      this.currentStudentId = ''
      this.currentStudentName = ''
      this.loadData()
    },
    changeSelect(record) {
      this.currentStudentId = record.studentId
      this.currentStudentName = record.studentName
      this.loadChartData(record.studentId)
    },
    loadChartData(studentId) {
      const isHasStu = this.studentLineArr.some((item) => item.studentInfo.studentId == studentId)
      if (isHasStu) {
        return
      }
      this.chartLoading = true
      this.queryParam.studentId = studentId
      this.queryParam.dataType = 1

      getAction(this.url.childWarnNumTrend, this.queryParam).then((res) => {
        if (res.success) {
          const { lineData, filedList } = handleLineChartData(res.result)
          const filterFileds = filedList.filter((item) => item != this.currentStudentName)
          const stuObj = {
            name: this.currentStudentName,
            fileds: [...filterFileds, this.currentStudentName],
            dataSource: lineData,
            studentInfo: {
              ...this.queryParam,
              id: this.currentStudentId,
              name: this.currentStudentName,
            },
          }
          this.studentLineArr.unshift(stuObj)
        }
        console.log('学生数据：', this.studentLineArr)

        this.chartLoading = false
      })
    },

    onRangeChange(dates, dateString) {
      this.rangeDate = dates

      this.queryParam.beginDate = dateString[0]
      this.queryParam.endDate = dateString[1]
      console.log("初始化第二次")
      this.getData()
    },
    showPic() {
      this.picLoading = true
      this.isShowPic = !this.isShowPic
      if (this.isShowPic) {
        this.param = JSON.parse(JSON.stringify(this.queryParam))
        this.param.pageNo = 1
        this.param.pageSize = 200
        this.param.column = 'createTime'
        this.param.order = 'desc'
        this.param.beginDate = moment(this.param.beginDate)
          .subtract(14, 'days')
          .format('YYYY-MM-DD')

        getAction(this.url.studentFaceList, this.param).then((res) => {
          if (res.success) {
            this.picData = this.jsonArrayGroup(res.result.records)
          }
          this.picLoading = false
        })
      }
    },

    jsonArrayGroup(arr) {
      var map = {},
        dest = []
      for (var i = 0; i < arr.length; i++) {
        var ai = arr[i]
        var key = ai.createTime.substring(0, 10)
        if (!map[key]) {
          dest.push({
            name: key,
            data: [ai],
          })
          map[key] = ai
        } else {
          for (var j = 0; j < dest.length; j++) {
            var dj = dest[j]
            if (dj.name == key) {
              dj.data.push(ai)
              break
            }
          }
        }
      }
      return dest
    },
    // 学生折线图信息导出
    derivedInfo() {
      const element = this.$refs.exportContent
      exportToPdf(element, '学生心理情绪档案')
    },
    /**
     * 导出excel携带情绪曲线
     */
    chartToImg() {
      var that = this
      that.exportChartData = []

      that.$confirm({
        title: '提示',
        content: '本次操作将会导出本页所有学生+情绪曲线，确定导出吗?',
        onOk() {
          that.loading = true
          var hide = that.$message.loading('正在获取学生情绪数据...', 0)

          getAction(that.url.getMoreStudentMoodData, that.queryParam).then((res) => {
            if (res.success) {
              res.result.forEach((item) => {
                // 本次请求唯一标识
                that.queryParam.key = item.key
                const { lineData, filedList } = handleLineChartData(item.data)
                const stuObj = {
                  id: item.unionId,
                  fileds: filedList,
                  dataSource: lineData,
                }
                that.exportChartData.push(stuObj)
              })
              setTimeout(hide, 0)

              // 增加延迟，避免页面没渲染完导致dom获取不全
              setTimeout(function () {
                // dom分片截取
                let sliceNum = parseInt(that.exportChartData.length / 200)
                let sliceArr = []
                for (let i = 1; i <= sliceNum; i++) {
                  sliceArr.push([(i - 1) * 200, 200])
                }
                sliceArr.push([sliceNum * 200, that.exportChartData.length % 200])

                that.doHtmlToCanvas(sliceArr)
              }, 2000)
            }
          })
        },
      })
    },
    // 曲线太多导致高度太高，html2canvas超出40000px会直接输出白板
    async doHtmlToCanvas(promiseArr) {
      let that = this
      var hide = that.$message.loading('正在生成学生情绪曲线...', 0)
      const element = window.document.getElementById('exportChart')
      if (element) {
        await Promise.all(
          promiseArr.map((ele) => {
            console.log(ele)
            return html2canvas(element, {
              scale: 1,
              y: ele[0] * 150,
              width: 500,
              height: ele[1] * 150,
              scrollX: 0,
              scrollY: 0,
            })
          })
        ).then((res) => {
          // 多次调用html2canvas会导致浏览器内存溢出，采用图片分片模式
          let unionIds = []
          let b64s = []
          let canvas = null

          // 创建切片
          for (let i = 0; i < res.length; i++) {
            canvas = res[i]

            for (
              let j = promiseArr[i][0];
              j < that.exportChartData.length && j < i * 200 + promiseArr[i][1];
              j++
            ) {
              let sliceCanvas = document.createElement('canvas')
              let sliceCtx = sliceCanvas.getContext('2d')
              sliceCanvas.width = 500
              sliceCanvas.height = 150

              // 将当前切片绘制到新 canvas 上
              sliceCtx.drawImage(canvas, 0, 150 * (j % 200), 500, 150, 0, 0, 500, 150)

              unionIds.push(that.exportChartData[j].id)
              b64s.push(sliceCanvas.toDataURL('image/png'))
            }
          }
          canvas = null

          // 上传截图
          postAction(that.url.uploadMoodDataImg, {
            unionIds: unionIds,
            b64s: b64s,
          }).then((res) => {
            setTimeout(hide, 0)
            that.$message.loading('正在生成excel...', 5)
            that.handleExportXls('学生情绪数据分析')
            that.loading = false
          })
        })
      }
    },
    // 列表查看详情
    showLineDetail(record) {
      console.log('行信息--', record)
      this.$refs.viewKeyPointModal.show({ id: record.studentId, name: record.studentName }, 2)
    },
    showAddLabel(record) {
      const recordData = {
        studentId: record.studentId,
        // keyword: record.studentName,
        beginDate: this.formData.beginDate,
        endDate: this.formData.endDate,
      }
      this.$refs.addLabelModal.show(recordData)
    },
    // 查看照片详情
    showImgDetail(dataInfo) {
      this.$refs.imgTimeLineModal.show(dataInfo)
    },
    deleteRecord(currStuInfo) {
      const index = this.studentLineArr.findIndex((item) => item.studentInfo.id == currStuInfo.id)
      if (index != -1) {
        this.studentLineArr.splice(index, 1)
        this.$message.success('删除卡片项成功')
      } else {
        this.$message.warning('记录不存在，删除失败')
      }
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style>
.ant-table-fixed-header .ant-table-scroll .ant-table-header {
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  overflow: hidden !important;
  opacity: 0.9999;
  padding-right: 8px;
}
</style>
